import { partyBagProducts } from '../../../mocks/collections';

export default function PartyBags() {
  return (
    <section id="party-bags" className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 bg-[#EB9830] rounded-full"></span>
            <span className="text-sm uppercase tracking-wider text-[#EB9830] font-semibold">
              KIDS PARTY COLLECTION
            </span>
            <span className="w-2 h-2 bg-[#EB9830] rounded-full"></span>
          </div>
          <h2 className="text-5xl font-serif font-bold text-[#574407] mb-4">
            Party Bags &amp; Gift Souvenirs
          </h2>
          <p className="text-base text-[#936A0B] max-w-2xl mx-auto leading-relaxed">
            Make every celebration unforgettable with our beautifully curated party bags.
            Perfect for birthdays, baby showers, and special occasions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {partyBagProducts.map((product) => (
            <a
              key={product.id}
              href="#contact"
              className="group bg-[#E2D9CA]/30 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 cursor-pointer block"
            >
              <div className="relative w-full h-72 overflow-hidden bg-[#E2D9CA]/40 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  title={`${product.name} - ABEXIA Party Bags`}
                  className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute top-3 right-3 bg-[#574407] text-white text-xs font-bold px-3 py-1.5 rounded-lg">
                  {product.price}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-serif font-semibold text-[#574407] mb-2 group-hover:text-[#936A0B] transition-colors">
                  {product.name}
                </h3>
                <p className="text-sm text-[#936A0B]/80 mb-4 leading-relaxed">{product.description}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1.5">
                    {product.colors.map((color, idx) => (
                      <span
                        key={idx}
                        className="text-xs text-[#936A0B]/60 bg-[#E2D9CA]/60 px-2 py-0.5 rounded-full"
                      >
                        {color}
                      </span>
                    ))}
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EB9830]/10 group-hover:bg-[#EB9830] transition-colors duration-300">
                    <i className="ri-arrow-right-line text-sm text-[#EB9830] group-hover:text-white transition-colors"></i>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
